import { AppTheme } from "./theme.type";

export const getThemePalette = () => ({
  common: {
    black: "#000000",
    white: "#ffffff",
  },
  primary: {
    light: "#667eea", // Modern blue-purple
    main: "#5a67d8", // Vibrant indigo
    dark: "#4c51bf", // Deep indigo
    "200": "#c7d2fe", // Very light indigo
    "800": "#3b3663", // Very dark indigo
  },
  secondary: {
    light: "#f093fb", // Light pink-purple
    main: "#f093fb", // Gradient pink
    dark: "#f5576c", // Deep pink
    "200": "#fce7f3", // Very light pink
    "800": "#be185d", // Very dark pink
  },
  error: {
    light: "#fca5a5", // Light red
    main: "#ef4444", // Modern red
    dark: "#dc2626", // Deep red
  },
  warning: {
    light: "#fde68a", // Light amber
    main: "#f59e0b", // Modern amber
    dark: "#d97706", // Deep amber
  },
  success: {
    light: "#86efac", // Light green
    main: "#10b981", // Modern emerald
    dark: "#059669", // Deep emerald
  },
  info: {
    light: "#93c5fd", // Light blue
    main: "#3b82f6", // Modern blue
    dark: "#2563eb", // Deep blue
  },
  grey: {
    50: "#f9fafb",
    100: "#f3f4f6",
    200: "#e5e7eb",
    300: "#d1d5db",
    400: "#9ca3af",
    500: "#6b7280",
    600: "#4b5563",
    700: "#374151",
    800: "#1f2937",
    900: "#111827",
  },
  text: {
    primary: "#1f2937", // Dark grey
    secondary: "#6b7280", // Medium grey
    title: "#ffffff", // White for titles
  },
  background: {
    default: "#f8fafc", // Light grey
    darkPaper: "#1f2937", // Dark grey
    dark: "#111827", // Very dark grey
    paper: "#ffffff", // White
  },
  section: {
    light: "#f9fafb",
    main: "#f3f4f6",
    border: "#e5e7eb",
  },
  button: {
    primary: {
      default: {
        background: "#5a67d8",
        color: "#ffffff",
      },
      hover: {
        background: "#4c51bf",
        color: "#ffffff",
      },
      disabled: {
        background: "#d1d5db",
        color: "#9ca3af",
      },
    },
    secondary: {
      default: {
        background: "#f3f4f6",
        color: "#374151",
      },
      hover: {
        background: "#e5e7eb",
        color: "#1f2937",
      },
      disabled: {
        background: "#f3f4f6",
        color: "#9ca3af",
      },
    },
  },
});

export const appTheme: AppTheme = {
  emptyState: {
    width: "100%",
    height: "150px",
    labelFontSize: "18px",
  },
};
